import "../css/donate.css";
import qrCodeImage from "../assets/Initiatives/1aa18b40-10af-4cd8-8fae-517770154446.jpeg";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import BackToTop from "../components/BackToTop";
import PageHeader from "../components/PageHeader";
import { useState } from "react";
import { useSelector } from "react-redux";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
// import { Dropdown } from 'primereact/dropdown';
// import 'primereact/resources/themes/lara-light-indigo/theme.css';
// import 'primereact/resources/primereact.min.css';

// import Dropdown from 'react-dropdown';
// import 'react-dropdown/style.css';

export default function Donate() {
  const path = useLocation().pathname;
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [mobileNumber, setMobileNumber] = useState("");
  const [amount, setAmount] = useState("");
  const [donationPurpose, setDonationPurpose] = useState("");
  const [agreeToTerms, setAgreeToTerms] = useState(false);
  const MySwal = withReactContent(Swal);

  const currentTheme = useSelector((state) => state.theme.current);

  const donationOptions = [
    { value: "Mustahab Sadaqah", label: "Mustahab Sadaqah" },
    { value: "Wajib Sadaqah", label: "Wajib Sadaqah" },
    { value: "Fitrah", label: "Fitrah" },
    { value: "Fidya(Kaffarah)", label: "Fidya(Kaffarah)" },
    { value: "Donation", label: "Donation" },
    { value: "Sahm-E-Sadaat", label: "Sahm-E-Sadaat" },
    { value: "Sahm-E-Imam", label: "Sahm-E-Imam" },
    { value: "Others", label: "Others" },
  ];

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!agreeToTerms) {
      MySwal.fire({
        title: "Agreement Required",
        text: "You must agree to the terms and conditions",
        icon: "warning",
      });
      return;
    }

    const nameRegex = /^[A-Za-z\s]+$/;
    if (!nameRegex.test(name)) {
      MySwal.fire({
        title: "Invalid Name",
        text: "Please enter a valid name (letters and spaces only).",
        icon: "warning",
      });
      return;
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      MySwal.fire({
        title: "Invalid Email",
        text: "Please enter a valid email address.",
        icon: "warning",
      });
      return;
    }

    const mobileRegex = /^\d{10}$/;
    if (!mobileRegex.test(mobileNumber)) {
      MySwal.fire({
        title: "Invalid Mobile Number",
        text: "Please enter a valid 10-digit mobile number.",
        icon: "warning",
      });
      return;
    }

    if (isNaN(amount) || Number(amount) <= 0) {
      MySwal.fire({
        title: "Invalid Amount",
        text: "Please enter a valid donation amount",
        icon: "warning",
      });
      return;
    }

    // Display QR Code with charity quote and download button
    MySwal.fire({
      title:
        "<h3>Charity begins at home, but it doesn’t have to end there.</h3>",
      html: `
                <div>
                    <img 
                        src="${qrCodeImage}" 
                        alt="QR Code for donation" 
                        style="width: 300px; height: 300px; margin-bottom: 15px;" 
                    />
                    <a 
                        href="${qrCodeImage}" 
                        download="Donation_QR_Code.jpeg"
                        style="
                            text-decoration: none;
                            padding: 10px 20px; 
                            background-color: #fdbe33; 
                            color: white; 
                            font-size: 16px; 
                            border: none; 
                            border-radius: 5px; 
                            cursor: pointer;"
                    >
                        Download QR
                    </a>
                </div>
            `,
      showCloseButton: true,
      showConfirmButton: false,
      allowOutsideClick: true,
      allowEscapeKey: true,
      allowEnterKey: true,
    });
  };

  const resetForm = () => {
    setName("");
    setEmail("");
    setMobileNumber("");
    setAmount("");
    setDonationPurpose("Khums");
    setAgreeToTerms(false);
  };

  return (
    <>
      <Navbar />
      <PageHeader title={"Donate Now"} />
      <div className="donations" style={{ background: `${currentTheme}` }}>
        <div className="container">
          <div className="donate">
            <div className="row align-items-center">
              <div className="col-lg-7">
                <div className="donate-content">
                  <div className="section-header">
                    {/* <p>Donate Now</p>
                                        <h2>Let's donate to needy people for better lives</h2> */}
                  </div>
                  <div className="donate-text">
                    <h3 style={{ color: "rgb(170, 130, 28)" }}>
                      Rasule Khuda (saww) :-
                    </h3>
                    <p style={{ color: "" }}>
                      Se puchha gaya ke kaun sa Sadqa behtar hai? Aap (saww) ne
                      farmaya, "Dushman rishte-daar ko Sadqa dena behtar hai".
                      Sawaabul Aamaal, p305
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-lg-5">
                <div className="donate-form">
                  <form onSubmit={handleSubmit}>
                    <div className="control-group">
                      <input
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                        type="text"
                        className="form-control"
                        placeholder="Full Name"
                        required
                      />
                    </div>
                    <div className="control-group">
                      <input
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        type="email"
                        className="form-control"
                        placeholder="Email"
                        required
                      />
                    </div>
                    <div className="control-group">
                      <input
                        value={mobileNumber}
                        onChange={(e) => setMobileNumber(e.target.value)}
                        type="tel"
                        className="form-control"
                        placeholder="Mobile Number"
                        required
                      />
                    </div>
                    <div className="control-group">
                      <input
                        value={amount}
                        onChange={(e) => setAmount(e.target.value)}
                        type="number"
                        className="form-control"
                        placeholder="Enter donation amount"
                        required
                        min="1"
                      />
                    </div>

                    {/* <div className="control-group">
                                        <Dropdown 
                                            value={donationPurpose} 
                                            onChange={(e) => setDonationPurpose(e.value)} 
                                            options={donationOptions}
                                            className="form-control" 
                                            />
                                           </div> */}

                    <div className="control-group">
                      <select
                        className="dropdown-button"
                        value={donationPurpose}
                        onChange={(e) => setDonationPurpose(e.target.value)}
                        required
                      >
                        <option value="Khums">Mustahab Sadaqah</option>
                        <option value="Sadaqah">Wajib Sadaqah</option>
                        <option value="Fitrah">Fitrah</option>
                        <option value="Fidya(Kaffarah)">Fidya(Kaffarah)</option>
                        <option value="Donation">Donation</option>
                        <option value="Sahm-E-Sadaat">Sahm-E-Sadaat</option>
                        <option value="Sahm-E-Imam">Sahm-E-Imam</option>
                        <option value="Others">Others</option>
                      </select>
                    </div>

                    <div className="control-group">
                      <Link
                        to="/TermsAndPrivacyPolicy"
                        className={`nav-item nav-link ${
                          path === "/TermsAndPrivacyPolicy" ? "active" : ""
                        }`}
                      >
                        <i className="fa fa-angle-right"></i> Terms and
                        Conditions
                      </Link>
                      <input
                        type="checkbox"
                        checked={agreeToTerms}
                        onChange={(e) => setAgreeToTerms(e.target.checked)}
                        required
                      />
                      <label>&nbsp; I accept the terms and conditions</label>
                    </div>

                    <div>
                      <button
                        className="btn btn-custom"
                        type="submit"
                        style={{ borderRadius: "12px" }}
                      >
                        Donate Now
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
      <BackToTop />
    </>
  );
}
